/**
 * Servicio para manejar la configuración del sistema
 */
import apiClient from './apiClient.js'

class ConfigService {

  cache = null;

  /**
   * Obtener configuración del sistema
   */
  async getConfig(fromCache = true) {
    try {
      if (fromCache && this.cache) {
        console.log('✅ Configuración obtenida de caché:', this.cache)
        return this.cache
      }

      console.log('📡 Obteniendo configuración...')
      const response = await apiClient.get('/config')

      if (response.data.success) {
        console.log('✅ Configuración obtenida:', response.data.data)
        this.cache = response.data.data // Guardar en caché
        return response.data.data
      } else {
        throw new Error(response.data.message || 'Error obteniendo configuración')
      }
    } catch (error) {
      console.error('❌ Error obteniendo configuración:', error)
      throw error
    }
  }

  async getConfigText(fieldName, language, fallbackText = '') {
    // Navegar por la estructura de secciones (ej: general.loadingText)
    const parts = fieldName.split('.')
    let config = await this.getConfig();

    for (const part of parts) {
      if (config && typeof config === 'object') {
        config = config[part]
      } else {
        config = null
        break
      }
    }

    if (config && config[language]) {
      return config[language]
    }
    return fallbackText 
  }

  /**
   * Actualizar configuración del sistema
   */
  async updateConfig(configData) {
    try {
      console.log('📡 Actualizando configuración del sistema...')
      console.log('📄 Datos:', configData)

      const response = await apiClient.put('/config', configData)

      if (response.data.success) {
        console.log('✅ Configuración actualizada exitosamente')
        return response.data.data
      } else {
        throw new Error(response.data.message || 'Error actualizando configuración')
      }
    } catch (error) {
      console.error('❌ Error actualizando configuración:', error)
      throw error
    }
  }

  /**
   * Actualizar un campo específico de la configuración
   */
  async updateConfigField(field, value) {
    try {
      console.log(`📡 Actualizando campo ${field}...`)
      console.log('📄 Valor:', value)

      const response = await apiClient.patch(`/config/${field}`, { value })

      if (response.data.success) {
        console.log(`✅ Campo ${field} actualizado exitosamente`)
        return response.data.data
      } else {
        throw new Error(response.data.message || `Error actualizando campo ${field}`)
      }
    } catch (error) {
      console.error(`❌ Error actualizando campo ${field}:`, error)
      throw error
    }
  }

  /**
   * Resetear configuración a valores por defecto
   */
  async resetConfig() {
    try {
      console.log('📡 Reseteando configuración a valores por defecto...')

      const response = await apiClient.post('/config/reset')

      if (response.data.success) {
        console.log('✅ Configuración reseteada exitosamente')
        return response.data.data
      } else {
        throw new Error(response.data.message || 'Error reseteando configuración')
      }
    } catch (error) {
      console.error('❌ Error reseteando configuración:', error)
      throw error
    }
  }

  /**
   * Obtener solo el título en todos los idiomas
   */
  async getTitle() {
    try {
      console.log('📡 Obteniendo título del sistema...')
      const response = await apiClient.get('/config/title')

      if (response.data.success) {
        console.log('✅ Título obtenido:', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message || 'Error obteniendo título')
      }
    } catch (error) {
      console.error('❌ Error obteniendo título:', error)
      throw error
    }
  }
}

// Crear instancia única del servicio
const configService = new ConfigService()

export default configService
